import { render, staticRenderFns } from "./ReceitaForm.vue?vue&type=template&id=38d90f29"
import script from "./ReceitaForm.vue?vue&type=script&lang=js"
export * from "./ReceitaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports